import React from 'react';
import { Mail } from 'lucide-react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-700" />
      <div className="absolute inset-0 bg-slate-900/50" />
      <motion.div 
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
        className="container relative mx-auto px-4 z-10"
      >
        <div className="max-w-2xl mx-auto text-center">
          <motion.h2 
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold text-white mb-4"
          >
            Subscribe to our newsletter
          </motion.h2>
          <motion.p 
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-indigo-100 mb-8"
          >
            Get the latest articles and news delivered to your inbox
          </motion.p>
          <motion.div 
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <div className="relative w-full sm:w-64">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="pl-10 pr-4 py-3 rounded-full text-slate-900 w-full focus:outline-none focus:ring-2 focus:ring-white/50"
              />
              <Mail className="absolute left-3 top-3 h-5 w-5 text-slate-400" />
            </div>
            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 bg-white text-indigo-600 rounded-full font-medium hover:bg-indigo-50 transition-colors shadow-xl shadow-indigo-800/20"
            >
              Subscribe
            </motion.button>
          </motion.div>
        </div>
      </motion.div>
      
      {/* Abstract Shapes */}
      <div className="absolute -bottom-16 -left-16 h-64 w-64 rounded-full bg-indigo-500/20 blur-3xl" />
      <div className="absolute -top-8 -right-8 h-40 w-40 rounded-full bg-purple-500/20 blur-2xl" />
    </section>
  );
};

export default Footer;